import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10ffe356")

_pushScopeId("data-v-10ffe356")
const _hoisted_1 = {
  key: 1,
  class: "p-d-flex p-flex-column chipsContainer"
}
const _hoisted_2 = { id: "chips-help" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Chips = _resolveComponent("Chips")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mt-2 p-mx-2" }, {
      start: _withId(() => [
        (!_ctx.expandParamsCard)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-chevron-right",
              class: "p-button-text p-button-rounded p-button-plain",
              style: {"color":"white"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandParamsCard = true))
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-chevron-down",
              class: "p-button-text p-button-rounded p-button-plain",
              style: {"color":"white"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expandParamsCard = false))
            })),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('managers.datasetManagement.params')), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_Button, {
          icon: "fas fa-plus",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.addNewParam
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          icon: "fas fa-eraser",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.disableDeleteAll,
          onClick: _ctx.removeAllParams
        }, null, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_Card, { class: "p-mx-2" }, {
      content: _withId(() => [
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm kn-table",
          editMode: "cell",
          value: _ctx.dataset.pars,
          scrollable: true,
          scrollHeight: "250px",
          dataKey: "versNum",
          responsiveLayout: "stack",
          breakpoint: "960px",
          onCellEditComplete: _ctx.onCellEditComplete
        }, {
          empty: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.tableEmpty')), 1)
          ]),
          default: _withId(() => [
            _createVNode(_component_Column, {
              field: "name",
              header: _ctx.$t('kpi.alert.name'),
              sortable: true
            }, {
              body: _withId(({ data }) => [
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  style: _ctx.tableDescriptor.style.columnStyle,
                  modelValue: data.name,
                  "onUpdate:modelValue": ($event: any) => (data.name = $event)
                }, null, 8, ["style", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "type",
              header: _ctx.$t('kpi.alert.type'),
              sortable: true
            }, {
              body: _withId(({ data }) => [
                _createVNode(_component_Dropdown, {
                  id: "scope",
                  class: "kn-material-input",
                  style: _ctx.tableDescriptor.style.columnStyle,
                  options: _ctx.datasetParamTypes,
                  optionLabel: "value",
                  optionValue: "value",
                  modelValue: data.type,
                  "onUpdate:modelValue": ($event: any) => (data.type = $event)
                }, null, 8, ["style", "options", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "defaultValue",
              header: _ctx.$t('managers.driversManagement.useModes.defaultValue'),
              sortable: true
            }, {
              body: _withId(({ data }) => [
                (data.multiValue === false)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      class: "kn-material-input",
                      style: _ctx.tableDescriptor.style.columnStyle,
                      modelValue: data.defaultValue,
                      "onUpdate:modelValue": ($event: any) => (data.defaultValue = $event)
                    }, null, 8, ["style", "modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createBlock("div", _hoisted_1, [
                      _createVNode(_component_Chips, {
                        class: "kn-border-none",
                        modelValue: data.defaultValue,
                        "onUpdate:modelValue": ($event: any) => (data.defaultValue = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode("small", _hoisted_2, _toDisplayString(_ctx.$t('common.chipsHint')), 1)
                    ]))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "multiValue",
              header: _ctx.$t('managers.profileAttributesManagement.form.multiValue'),
              sortable: true
            }, {
              body: _withId(({ data }) => [
                _createVNode(_component_Checkbox, {
                  modelValue: data.multiValue,
                  "onUpdate:modelValue": ($event: any) => (data.multiValue = $event),
                  binary: true,
                  onChange: ($event: any) => (_ctx.checkboxChange(data))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, { onRowClick: false }, {
              body: _withId((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.deleteParam(slotProps))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "onCellEditComplete"])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.expandParamsCard]
    ])
  ], 64))
})